import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import DiamondLinksEmailTemplateService from "../../../services/diamondLinks-emailTemplate.service";
import { Button, Modal, Spin, Tooltip } from "antd";


export const MasterLinkEmailTemplate = (props) => {
  const { t } = useTranslation();
  const [typeName, setTypeName] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  /*API Binding Starts*/

  //Dropdown List Starts
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [dealerId, setDealerId] = useState(0);
  const [relaod, setReload] = useState(false);
  const [content, setContent] = useState("");
  const [
    diamondEmailTemplatesDetailsList,
    setDiamondEmailTemplatesDetailsList,
  ] = useState([]);
  const [emailData, setEmailData] = useState("");
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setDealerId(loginDetials.responseData.dealerId);
      }
    }
  }, []);

  //Dropdown List Ends

  const handleEmailUpdate = () => {
    handleUpdateDiamondLinkEmailTemplateDetails(
      loginDetials.responseData.dealerId
    );
  };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("uploadImg", file);
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const refreshPage = () => {
    setVisible(false);
    setReload(!relaod);
  };

  const handleGetDiamondEmailTemplatesDetails = (name, id) => {
    try {
      let inputData = {
        dealerID: dealerId || id,
        typeName: name,
      };
      setContent("");
      setVisible(true);
      setTypeName(name);
      setLoading(true);
      DiamondLinksEmailTemplateService.GetDiamondEmailTemplatesDetails(
        inputData
      )
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          let diamondEmailTemplatesDetailsList =
            response.data.responseData[0].emailContent;
          if (message === "Success") {
            if (responseData) {
              setDiamondEmailTemplatesDetailsList(
                diamondEmailTemplatesDetailsList
              );
              setContent(responseData[0].emailContent);
              setEmailData(diamondEmailTemplatesDetailsList);
              setLoading(false);
            } else {
              setDiamondEmailTemplatesDetailsList([]);
              setLoading(false);
            }
          } else {
            setDiamondEmailTemplatesDetailsList([]);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleUpdateDiamondLinkEmailTemplateDetails = (id) => {
    try {
      let inputData = {
        dealerID: dealerId || id,
        typeName: typeName,
        emailContent: content,
      };
      DiamondLinksEmailTemplateService.UpdateDiamondLinkEmailTemplateDetails(
        inputData
      )
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(
              t("Email Templates Updated Successfully.")
            );
          } else {
            NotificationManager.error(t("Email Templates Not Update."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*API Binding Ends*/

  return (
    <div className="form__fields">
      <div className="row">
        <div className="col-md-12">
          <h4 className="workarea__heading mt-0">
            {" "}
            {""} {t("Contact Emails (MasterLink)")} {""}{" "}
          </h4>
        </div>
      </div>

      <div className="emailTemplate">
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Customer Registration")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustomerRegistration"
                      )
                    }
                  >
                    {""} {t("Customer Registration")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("New Appointments")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustNewAppointments"
                      )
                    }
                  >
                    {""} {t("New Appointments")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Inquires (Request More Info)")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustMoreInfoRetailer"
                      )
                    }
                  >
                    {""} {t("Send Mail to Retailer")} {""}{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustMoreInfoSender"
                      )
                    }
                  >
                    {""} {t("Send Mail to Sender")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Inquires (Request More Info)")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("ToFriendInquires")
                    }
                  >
                    {t("Send Mail to Friend")}
                  </Link>
                </li>

                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("CustInquires")
                    }
                  >
                    {""} {t("Send Mail to Retailer")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("ToSenderInquires")
                    }
                  >
                    {""} {t("Send Mail to Sender")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Drop A Hint")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "ToRecipientDropAHint"
                      )
                    }
                  >
                    {""} {t("Send Mail to Recipient")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "ToRetailerDropAHint"
                      )
                    }
                  >
                    {""} {t("Send Mail to Retailer")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("New Favourite List")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustNewFavoriteList"
                      )
                    }
                  >
                    {""} {t("New Favourite List")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("New Favourite Items Added")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "CustNewFavoriteItem"
                      )
                    }
                  >
                    {""} {t("New Favourite Items Added")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Conversations")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("CustConversations")
                    }
                  >
                    {""} {t("Conversations")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Customer Reset Password")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("CustResetPassword")
                    }
                  >
                    {""} {t("Customer Reset Password")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="emailTemplateEditorModal"
        title={t("Send Email")}
        centered
        visible={visible}
        onOk={() => {
          setVisible(false);
          handleEmailUpdate();
        }}
        onCancel={refreshPage}
        width={800}
        hieght={600}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={refreshPage}>
            {t("Cancel")}
          </Button>,
          <Button
            className="primary-btn"
            onClick={() => {
              setVisible(false);
              handleEmailUpdate();
            }}
          >
            {t("Save")}
          </Button>,
        ]}
      >
        <div className="editor__section">
          <Spin spinning={loading}>
            <CKEditor
              key={relaod}
              config={{
                extraPlugins: [uploadPlugin],
              }}
              editor={ClassicEditor}
              data={content ? content : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                setContent(data);
              }}
            />
          </Spin>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MasterLinkEmailTemplate);
